export class SectionCourseLoader {
  constructor(controller) {
    this.controller = controller;
  }

  loadSectionCourse() {
    fetch('/api/v1/page_editor/course_card', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Не удалось загрузить карточку курса!");
        }
      })
      .then(data => {
        const firstSection = document.querySelector('section');
        if (firstSection && data.html) {
          // Create a temporary container to parse the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.html;

          // Insert the course card after the first section
          firstSection.parentNode.insertBefore(tempDiv.firstElementChild, firstSection.nextSibling);

          // Reinitialize editor functionality for the new element
          // this.initializeTextEditor();
          // this.initializeSectionControls();

          this.controller.showToaster("Карточка курса успешно добавлена!");
        } else if (!firstSection) {
          this.controller.showToaster("Раздел не найден в документе!");
        }
      })
      .catch(error => {
        console.error("Ошибка при загрузке карточки курса:", error);
        this.controller.showToaster("Ошибка при загрузке карточки курса.");
      });
  }
}
